var React = require('react');

function NextInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.40501 6.00007C7.40501 6.22007 7.32502 6.42007 7.16502 6.58007L1.96502 11.5801C1.80502 11.7201 1.60501 11.8001 1.40501 11.8001C1.18501 11.8001 0.985003 11.7201 0.825003 11.5601C0.525003 11.2401 0.524998 10.7401 0.844998 10.4201L5.445 6.00007L0.844998 1.58007C0.524998 1.28007 0.525003 0.760073 0.825003 0.440073C1.125 0.120073 1.64502 0.120071 1.96502 0.420071L7.16502 5.42007C7.32502 5.58007 7.40501 5.78007 7.40501 6.00007Z","fill":"white"}));
}

NextInline.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = NextInline;

NextInline.default = NextInline;
